import { createChangeSignal } from "../../../shared/state/changeSignal";

/**
 * "The list of Threads changed here": a Thread was started, forked or closed in this tab, its
 * other pane or another tab, so the list is read again while the live socket's project feed is
 * not current (`useProjectThreads`); while it is, the feed brings the change.
 */
const threadList = createChangeSignal("thread-list");

export const notifyThreadListChanged = threadList.notify;
export const onThreadListChanged = threadList.subscribe;
